import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import { useCallback, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import ScreenBanner from "../../../../../components/ScreenBanner";
import ListaAcoesRapidas, { TItemAcaoRapida } from "../../../../../components/ListaAcoesRapidas";
import DialogIncluirEditarIngredienteAtivo from "../DialogIncluirEditarIngredienteAtivo";
import { ConfirmProvider } from "material-ui-confirm";
import SessaoConfiguracao from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";
import PermissaoTelaVazia from "../../../../../components/PermissaoTelaVazia";
import { IIngredienteAtivo } from "../DialogIncluirEditarIngredienteAtivo";
import PermissionGuard, { usePermission } from "../../../../../components/PermissionGuard";

export default function Listagem() {

    const listaAcoesRapidas: Array<TItemAcaoRapida> = [
        {
            label: "Incluir ingrediente ativo",
            icon: <AddIcon color="primary" />,
            action: () => handleModalAction("open", true, null),
            havePermission: usePermission("receituario.incluir-ingrediente-ativo"),
        }
    ];

    const [openModal, setOpenModal] = useState<TOpenModalIngredientesAtivos>(null);

    const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: IIngredienteAtivo | null) => {
        if (action === "close") setOpenModal(null);
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value });
        if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null });
    }, []);

    function RenderListagem() {
        return (
            <SessaoConfiguracao<IIngredienteAtivo>
                titulo="Lista de Ingredientes Ativos"
                endpoints={{
                    listar: "/receituario-agronomico/ingredientes-ativos/pesquisar-ingrediente-ativo",
                    deletar: "/receituario-agronomico/ingredientes-ativos/excluir-ingrediente-ativo",
                }}
                possuiAdicionar={false}
                colunas={colunas}
                queryKey="pesquisar-ingredientes-ativos"
                onEditar={item => handleModalAction("open", item.id, item)}
                onAdicionar={() => handleModalAction("open", true, null)}
                mensagemSucessoDeletar="Ingrediente ativo deletado com sucesso!"
                mensagemErroDeletar="Erro ao deletar ingrediente ativo!"
                mensagemSemDados="Nenhum ingrediente ativo encontrado."
            />
        );
    }

    return (
        <ConfirmProvider
            defaultOptions={{
                title: "Excluir ingrediente ativo",
                cancellationText: "Cancelar",
                confirmationText: "Excluir",
                confirmationButtonProps: { variant: "contained", color: "error" }
            }}
        >
            <ScreenBanner title="Receituário Agronômico" />
            <PermissionGuard permissionId="receituario.listar-ingredientes-ativos">
                <Container sx={{ mt: 3 }}>
                    <Typography textAlign="center" variant="h5">Ingredientes Ativos</Typography>
                    <Grid container spacing={2} mt={1}>
                        <Grid size={{xs: 12, md: 3}}>
                            <ListaAcoesRapidas items={listaAcoesRapidas} fullHeight={false} />
                        </Grid>
                        <Grid size={{xs: 12, md: 9}}>
                            <Box component={Paper}>
                                <Box px={2} pb={2}>
                                    <RenderListagem />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>

                {!!openModal && (
                    <DialogIncluirEditarIngredienteAtivo
                        defaultValue={openModal?.defaultValue}
                        open={!!openModal}
                        handleClose={() => handleModalAction("close", true)}
                    />
                )}
            </PermissionGuard>
        </ConfirmProvider>
    );
}

export type TOpenModalIngredientesAtivos = {
    open: number | boolean | null;
    defaultValue: IIngredienteAtivo | null;
} | null;

const colunas = [
    {
        campo: "nome" as keyof IIngredienteAtivo,
        titulo: "Nome",
    }
];